<app-shared-loading *ngIf="loading"></app-shared-loading>

<h1 *ngIf="isBiAgencyPaymethod; else isNotBiAgency" class="center">{{ 'title-pay-agency-BI' | translation | async }}</h1>
<ng-template #isNotBiAgency>
  <h1 *ngIf="isBiAgentPaymethod; else isNotBiAgent" class="center">{{ 'title-pay-agents-BI' | translation | async }}</h1>
</ng-template>
<ng-template #isNotBiAgent>
  <h1 *ngIf="isBamPaymethod; else super24" class="center">{{ 'title-pay-agents-bam' | translation | async }}</h1>
</ng-template>
<ng-template #super24>
  <h1 *ngIf="isSuper24PayMethod; else principalOrImportant" class="center">{{ 'title-pay-super-24' | translation | async }}</h1>
</ng-template>
<ng-template #principalOrImportant>
  <h1 *ngIf="notCRC(); else importantHeader" class="center">{{ 'deposit-Title-Agent' | translation | async }}</h1>
</ng-template>
<ng-template #importantHeader>
  <h1 class="center">{{ 'deposit-Title-Agent-nosucur' | translation | async }} {{ getActualRC() | translation | async }}</h1>
</ng-template>

<app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>

<div class="methodForm">
  <app-counter-item *ngIf="viewReference && flagActive">
    <p innerHTML="{{ 'cashTransferReference' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item>

    <div *ngIf="isGuatemala(); else notGuatemala">
      <ng-container *ngIf="isSuper24PayMethod; else notSuper24">
        <p innerHTML="{{'deposit-RefPago-No-Cuenta-super24' | translation | async }}"></p>
      </ng-container>
      <ng-template #notSuper24>
        <ng-container *ngIf="isBiAgencyPaymethod; else notBiAgency">
          <p innerHTML="{{ 'deposit-RefPago-No-Cuenta-BI' | translation | async }}"></p>
        </ng-container>
        <ng-template #notBiAgency>
          <ng-container *ngIf="isBiAgentPaymethod; else notBiAgent">
            <p innerHTML="{{'deposit-RefPago-No-Cuenta-BI-B' | translation | async }}"></p>
          </ng-container>
          <ng-template #notBiAgent>
            <ng-container *ngIf="isBamPaymethod">
              <p innerHTML="{{'deposit-RefPago-No-Cuenta' | translation | async }}"></p>
            </ng-container>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>

    <ng-template #notGuatemala>
      <p innerHTML="{{'deposit-RefPago' | translation | async }}"></p>
    </ng-template>
    <app-copy-to-clipboard [value]="currentConcept?.number" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item *ngIf="isGuatemala()">
    <p innerHTML="{{ 'deposit-RefPago-bam-name' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="'Payvalida Guatemala S.A'" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <div>
    <p>{{ 'deposit-EmailInfo' | translation | async }}</p>

    <form [formGroup]="emailForm">
      <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('email') }">
        <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
        <input type="text" matInput name="email" placeholder="{{ 'forms-Email-Input' | translation | async }}"
               maxlength="150" formControlName="email" [readonly]="isControlReadOnly('email')"/>
        <mat-error *ngIf=" !emailForm.valid && emailForm.get('email').touched">
          <div *ngIf="emailForm.get('email').errors?.required"
               innerHTML="{{ 'forms-EmailRequired' | translation | async }}"></div>
          <div *ngIf="!emailForm.get('email').valid">{{ 'forms-EmailInvalid' | translation | async }}</div>
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <div *ngIf="isBamPaymethod || isBiAgencyPaymethod || isBiAgentPaymethod || isBancoNacionalDepositPayMethod">
    <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
  </div>
  <div class="otherInfo">
    <p *ngIf="isGuatemala(); else elseOtherInfo" innerHTML="{{ 'deposit-RefPago-bam-info-time' | translation | async }}"></p>
    <ng-template #elseOtherInfo>
      <p *ngIf="notCRC(); else importantContent" innerHTML="{{ 'cash-DocInfo' | translation | async }}"></p>
      <ng-template #importantContent>
        <p innerHTML="{{ 'html-important' | translation | async }}"></p>
      </ng-template>
      <p innerHTML="{{ 'cash-AproveTime' | translation | async }}"></p>
    </ng-template>
  </div>
</div>
